<script>

    import Employee from './Employee.svelte'

    const { items, onSelect } = $props();

</script>

<ul>
    {#each items as item}
        <li>
            <Employee {item} {onSelect} />
        </li>
    {/each}
</ul>

<style>

    ul { 
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(20em, 1fr));
        gap: 1.4em;
        padding: 0;
    }

    li {
        list-style: none;
    }

</style>